export default __webpack_public_path__ + "82357f40a0baba3a12efc562c6caf1f0.png";